import { useTranslation } from 'react-i18next';
import { ModulePlaceholderForm } from '../../components/ModulePlaceholderForm';

export default function NewShift() {
  const { t } = useTranslation('panel');
  return (
    <ModulePlaceholderForm
      title="New shift"
      listPath="/panel/shifts"
      tabs={[
        {
          key: 'basic',
          label: t('form.tabs.basic'),
          fields: [
            { key: 'name', label: 'Shift name', required: true, placeholder: 'Morning' },
            { key: 'startTime', label: 'Start time', placeholder: '09:00' },
            { key: 'endTime', label: 'End time', placeholder: '18:00' },
            { key: 'graceMinutes', label: 'Grace period (minutes)', type: 'number' },
          ],
        },
        {
          key: 'details',
          label: t('form.tabs.details'),
          fields: [
            { key: 'breakMinutes', label: 'Break duration (minutes)', type: 'number' },
            { key: 'overtimeAfterHours', label: 'Overtime starts after (hours)', type: 'number' },
            { key: 'weeklyOff', label: 'Weekly off', type: 'select', options: [
              { value: 'sunday', label: 'Sunday' },
              { value: 'saturday', label: 'Saturday' },
              { value: 'rotational', label: 'Rotational' },
            ] },
          ],
        },
        {
          key: 'documents',
          label: t('form.tabs.documents'),
          fields: [
            { key: 'description', label: 'Description', type: 'textarea' },
            { key: 'isActive', label: 'Active?', type: 'select', options: [
              { value: 'yes', label: 'Yes' },
              { value: 'no', label: 'No' },
            ] },
          ],
        },
        { key: 'review', label: t('form.tabs.review'), fields: [] },
      ]}
    />
  );
}
